module.exports = __webpack_public_path__ + "04298ecc79f072a2ce2c93ae3502945f.fbx";